import { useState } from 'react';
import { getUrlParams } from 'helpers/utils';
import { useAppSelector } from 'helpers/hooks';
import { getDonatePageData } from 'selectors/donatePage';
import { DONATE_SHOPPING_CART_PAGE_CATEGORY } from 'helpers/donate';

interface UseShareUrlOptions {
  userRefCode?: string;
  shareCurrentUrl?: boolean;
  selectedTags?: string[];
  shoppingCartIds?: string[];
}

export const useShareUrl = ({
  userRefCode,
  shareCurrentUrl,
  selectedTags,
  shoppingCartIds,
}: UseShareUrlOptions = {}) => {
  const donatePageData = useAppSelector(getDonatePageData);
  const { urlPartner, urlEvent, urlShoppingCart } = getUrlParams();
  const currentUrl = new URL(window.location.href);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const ref = userRefCode ? `?ref=${userRefCode}` : '';
  const partner = urlPartner ? `${ref ? '&' : '?'}p=${urlPartner}` : '';
  const event = urlEvent ? `${ref || partner ? '&' : '?'}event` : '';

  let tagParams = '';
  if (selectedTags) {
    selectedTags.forEach((item: string, i: number) => {
      tagParams += `${i === 0 && !ref && !partner && !event ? '?' : '&'}tags=${item.replace(
        / /g,
        '%20'
      )}`;
    });
  }

  const urlWithRefCode = `${currentUrl.origin}${currentUrl.pathname}${ref}${partner}${event}${tagParams}`;
  const baseUrlWithRefCode = `${currentUrl.origin}${ref}${partner}${event}${tagParams}`;

  const isShoppingCartPage = donatePageData?.page_category === DONATE_SHOPPING_CART_PAGE_CATEGORY;
  const resolvedShoppingCartIds = isShoppingCartPage
    ? (shoppingCartIds ?? urlShoppingCart)
    : undefined;

  const shoppingCartUrl = resolvedShoppingCartIds?.length
    ? (() => {
        const params = new URLSearchParams();
        if (userRefCode) params.set('ref', userRefCode);
        if (urlPartner) params.set('p', urlPartner);
        params.set('shopping-cart', resolvedShoppingCartIds.join(','));
        return `${currentUrl.origin}/donate?${params.toString()}`;
      })()
    : null;

  const handleShare = () => {
    const url = shoppingCartUrl ?? (shareCurrentUrl ? urlWithRefCode : baseUrlWithRefCode);
    navigator.clipboard.writeText(url);
    setIsPopupOpen(true);
    setTimeout(() => setIsPopupOpen(false), 2000);
  };

  return {
    handleShare,
    isPopupOpen,
    urlWithRefCode,
    setIsPopupOpen,
    baseUrlWithRefCode,
  };
};
